(function () {
  'use strict';

  var section = document.querySelector('#pdp-qcg-hero');
  if (!section) return;

  // ------------------------------------------------------------------
  // Headline word-wrap: split each word into its own styled span
  // ------------------------------------------------------------------

  var headline = section.querySelector('.pdp-qcg-hero__headline');
  if (headline) {
    var headlineText = headline.textContent.trim();
    var words = headlineText.split(' ');
    var fragment = document.createDocumentFragment();
    words.forEach(function (word) {
      if (word.length > 0) {
        var span = document.createElement('span');
        span.className = 'pdp-qcg-hero__headline-word';
        span.textContent = word + ' ';
        fragment.appendChild(span);
      }
    });
    headline.textContent = '';
    headline.appendChild(fragment);
  }

  // ------------------------------------------------------------------
  // Info wrapper scroll — scrolls to #pdp-funding-banner on click
  // ------------------------------------------------------------------

  var infoWrapper = section.querySelector('.pdp-qcg-hero__info-wrapper');
  if (infoWrapper) {
    infoWrapper.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var target = document.getElementById('pdp-funding-banner');
      if (target) {
        target.scrollIntoView({ behavior: 'smooth' });
      }
    });
  }

})();
